<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title2"></a><div class="title-frontMatter">
<div class="p"><span>Dear Reader,</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span>“Revenge is a dish best served cold.”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>The above line grabbed my attention the very first time I read it. Revenge is a strong, deep emotion—passion with a dark, sometimes bitter, side to it—and I have chosen it as the linking theme for my St. Fiacre’s books.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>I like the idea of my characters—all outwardly highly successful people—having a secret side to their natures. A side that can plot to avenge themselves, a side that might sometimes appall them, but that they are powerless to resist—for the darkest emotions are always the most irresistible....</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>What motivates revenge? It is always the sense of having been wronged, a chance to win after an earlier defeat. And like all deep, controlling passions, revenge has a knock-on effect.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>But don’t take my word for it—find out yourself from Geraint, Triss and Dominic....</span></div>
<div class="illustype_image_text"><div class="image_text"><img alt="e9781459262027_i0002.jpg" src="e9781459262027_i0002.jpg"/></div></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781459262027_fm02.vue?f8f5d7d8